import * as React from 'react';
const { useEffect, useState } = React;
const h = React.createElement;

export interface RowProps extends React.HTMLAttributes<HTMLDivElement> {
  gutter?: number | [number, number];
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Row: React.FC<RowProps> = function Row(props) {
  const { gutter = 0, children, className = '', style = {}, ...rest } = props;
  const gutterVal = Array.isArray(gutter) ? gutter[0] : gutter;
  return h(
    'div',
    {
      className: `flex flex-wrap ${className}`,
      style: { margin: gutterVal ? `0 -${gutterVal / 2}px` : undefined, ...style },
      ...rest,
    },
    children,
  );
};

export interface ColProps {
  span?: number;
  xs?: number;
  sm?: number;
  md?: number;
  lg?: number;
  xl?: number;
  children?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

const Col: React.FC<ColProps> = function Col(props) {
  const { span, xs, sm, md, lg, xl, children, className = '', style = {} } = props;

  // True responsive: pick the correct span based on current viewport width
  const [winWidth, setWinWidth] = useState<number>(
    typeof window !== 'undefined' ? window.innerWidth : 1024,
  );
  useEffect(() => {
    const onResize = () => setWinWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  let effectiveSpan = span ?? 24;
  if (xs !== undefined) effectiveSpan = xs;
  if (sm !== undefined && winWidth >= 576) effectiveSpan = sm;
  if (md !== undefined && winWidth >= 768) effectiveSpan = md;
  if (lg !== undefined && winWidth >= 992) effectiveSpan = lg;
  if (xl !== undefined && winWidth >= 1200) effectiveSpan = xl;

  const pct = `${(effectiveSpan / 24) * 100}%`;

  return h(
    'div',
    {
      className: `px-2 ${className}`,
      style: { width: pct, flex: `0 0 ${pct}`, ...style },
    },
    children,
  );
};

export { Row, Col };
